import { useMsal } from '@azure/msal-react'
import { useDisclosure } from '@chakra-ui/react'
import { t } from 'i18next'
import { PrimitiveAtom, useAtom } from 'jotai'
import { useEffect } from 'react'

import { addNotification } from '@/store/gigiChat/Notifications'
import { helpCenterSelectedTopicAtom, sendHelpData, showHelpCenterDrawerAtom } from '@/store/helpCenter'
import { ITopic } from '@/types/helpCenter'

import HelpCenterDrawer from './HelpCenter'

const Container = () => {
    const { accounts } = useMsal()
    const [selectedTopic] = useAtom<PrimitiveAtom<ITopic | null>>(helpCenterSelectedTopicAtom)
    const [isOpen, showHelpCenterDrawer] = useAtom<PrimitiveAtom<boolean>>(showHelpCenterDrawerAtom)
    const { onOpen, onClose } = useDisclosure()

    const handleSend = (message: string) => {
        if (selectedTopic?.id) {
            const userName: string = (accounts[0].name as string) || ''
            const title = t('global.helpCenter.drawer.body.title', { topic: selectedTopic?.name, name: userName })

            void sendHelpData({ title, message, id: selectedTopic.id }).then((res) => {
                if (res) {
                    addNotification('success', t('global.helpCenter.toast.success'))
                }
            })
        }
        handleClose()
    }

    const handleClose = () => {
        onClose()
        showHelpCenterDrawer(false)
    }

    useEffect(() => {
        if (isOpen) {
            onOpen()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen])

    return <HelpCenterDrawer isOpen={isOpen} handleSend={handleSend} onClose={handleClose} selectedTopic={selectedTopic} />
}

export default Container
